import { FC } from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { fontWeightClass, labelClass } from '~/assets/styles/classes/InputClasses';

interface Props {
  errors: { [key: string]: { message?: string } }; 
  currentScript: any;
  errorFieldName?: string;
  required:boolean
  labelName?: string;
  LABELS: {
    ScriptRequired: string;
    DropFileHere: string;
    DragDropFileHereOrClickHere: string;
    OrClickHere: string;
  };
  getRootProps: () => React.HTMLAttributes<HTMLElement>;
  getInputProps: () => React.InputHTMLAttributes<HTMLInputElement>;
  getInputClassFile: (errors: any, isDragActive: boolean) => string;
  isDragActive: boolean;
}

const SIMPLFile: FC<Props> = ({
  errors,
  currentScript,
  LABELS,
  labelName,
  getRootProps,
  getInputProps,
  getInputClassFile,
  isDragActive,
  errorFieldName = 'script',
  required=true
}) => {
  const labelStyle = `${labelClass} ${errors[errorFieldName]?.message ? 'text-red-500' : 'text-[#6B6F7B]'}`;

  let fileDisplay;
  if (currentScript && currentScript instanceof File) {
    fileDisplay = <p className={labelClass}>{currentScript.name}</p>;
  } else if (isDragActive) {
    fileDisplay = <p className={labelClass}>{LABELS.DropFileHere}</p>;
  } else {
    fileDisplay = (
      <div className={`w-full ${errors[errorFieldName] ? 'text-error' : ''}`}>
        <span className="flex justify-center w-24px h-24px">
          <InsertDriveFileOutlinedIcon
            sx={{
              width: '16.5px',
              height: '21px',
              top: '1.5px',
              left: '3.75px',
              b: '#6B6F7B',
              gap: '0px',
              color: errors[errorFieldName]?.message ? 'red' : '#6B6F7B',
            }}
          />
        </span>
        <label className={labelStyle}>{LABELS.DragDropFileHereOrClickHere}</label>
        <label className={labelStyle}>{LABELS.OrClickHere}</label>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className={`inline-block cursor-pointer text-sm ${fontWeightClass('bold')} ${errors[errorFieldName]?.message && 'text-error'}`}>
        {required && <span className="text-red-500">*</span>}
        <span className={`${errors[errorFieldName]?.message ? 'text-red-500' : ''}`}>
          {labelName}
        </span>
      </div>
      
      <div {...getRootProps()} className={getInputClassFile(errors, isDragActive)}>
        <input {...getInputProps()} />
        {fileDisplay}
      </div>

      {errors[errorFieldName] && !currentScript && (
        <div className="pt-1 mb-4 text-error text-sm">{errors[errorFieldName].message}</div>
      )}
    </div>
  );
};

export default SIMPLFile;